import { getPairingMethod } from '../../modules/pairing/pairing.utils';
import { PAIRING_METHOD } from '../../modules/pairing/pairing.constants';

const GDPR_API_CONSENT_KEY_MAPPING = {
  personalization: 'personalization',
  audienceMeasurement: 'analytics',
  targetedAdvertising: 'adtargeting',
  devicePairing: 'multidevicematching',
};

// To retrieve the last clip and pass it to the first item. Because we have a limit of 50 items and want to delete the oldest clips as we go along.
export const formatClipsObject = clips =>
  (clips || [])
    .filter(clip => Boolean(clip && clip.clipid))
    .reduceRight((acc, clip) => ({ ...acc, [clip.clipid]: clip }), {});

/**
 * Construct the payload for the GDPR api,
 * mapping to the corresponding attributes and
 * filtering cookies that are listed in the config
 * (exclude devicePairing from payload on salto, for instance).
 *
 * @param {Object} consents
 * @param {string} consents.personalization
 * @param {string} consents.audienceMeasurement
 * @param {string} consents.targetedAdvertising
 * @param {string} consents.devicePairing
 * @returns {Object}
 */
export const getFormattedConsents = consents => {
  const consentEntries = Object.entries(consents);

  return consentEntries
    .filter(([key, value]) => key !== undefined && value !== undefined)
    .reduce(
      (formattedConsents, [key, value]) => ({
        ...formattedConsents,
        [GDPR_API_CONSENT_KEY_MAPPING[key] || key]: { consent: value, form: 'explicit' },
      }),
      {},
    );
};

/**
 * Prefix a string with homeId-
 * @param {string} [homeId]
 * @returns {string|null}
 */
export const prefixWithHomeId = homeId => {
  if (typeof homeId !== 'string') return null;

  return `homeid-${homeId}`;
};

const ACCOUNT_COMPLETION_COUNTER = 'account_completion_counter';

const getAccountCompletionCount = () => parseInt(localStorage.getItem(ACCOUNT_COMPLETION_COUNTER), 10) || 0;

export const isAccountCompletionCounterReady = () => getAccountCompletionCount() >= 5;

export const incrementAccountCompletionCounter = () => {
  if (getPairingMethod() !== PAIRING_METHOD.SSI) {
    return;
  }

  localStorage.setItem(ACCOUNT_COMPLETION_COUNTER, getAccountCompletionCount() + 1);
};

export const resetAccountCompletionCounter = () => {
  localStorage.setItem(ACCOUNT_COMPLETION_COUNTER, 0);
};
